var map = {
	"./images/Human_holding_bread.jpeg": "a641",
	"./images/app_ons.png": "10fa",
	"./images/bread_outside.jpeg": "c920",
	"./images/broodhuys_logo.png": "51be",
	"./images/customBorders/customBorder1(dark).png": "aad6",
	"./images/customBorders/customBorder1(light).png": "c518",
	"./images/customer/1.jpeg": "8438",
	"./images/customer/2.jpeg": "9ff6",
	"./images/customer/3.jpeg": "1358",
	"./images/customer/4.jpeg": "2fbd",
	"./images/customer/5.jpeg": "4ad1",
	"./images/customer/6.jpeg": "1a51",
	"./images/customer/Bakkers.jpg": "7a57",
	"./images/customer/Bussen.jpg": "ed00",
	"./images/customer/Enkhuizen.jpg": "3c21",
	"./images/customer/Hem.jpg": "06d1",
	"./images/customer/Hoogkarspel.jpg": "ee25",
	"./images/customer/bakkers voor winkel.jpg": "6a36",
	"./images/customer/broodhuys__ok.jpg": "156f",
	"./images/customer/c/1.jpg": "a34b",
	"./images/customer/c/2.jpg": "477f",
	"./images/customer/sinterklaaspakketten.jpeg": "fb63",
	"./images/customer/traditional_way.png": "09b9",
	"./images/loader.svg": "a72f",
	"./images/whatsapp.png": "d253",
	"./logo copy.png": "d90a",
	"./logo.png": "cf05",
	"./sass/app.scss": "29d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";